import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { QuotingComponent } from './pages/quoting/quoting.component'
import { QuotingResolver } from './resolvers/quoting.resolver'

const routes: Routes = [
	{
		path: 'quoting',
		loadChildren: () => import('./pages/quoting/quoting.module').then((m) => m.QuotingModule),
		// component: QuotingComponent,
		// resolve: { setup: QuotingResolver },
		// children: [
		// 	{
		// 		path: 'start-quote',
		// 		loadChildren: () =>
		// 			import('./pages/quoting/start-quote/start-quote.module').then((m) => m.StartQuoteModule),
		// 	},
		// 	{
		// 		path: 'referral',
		// 		loadChildren: () =>
		// 			import('./pages/quoting/referral-info/referral-info.module').then(
		// 				(m) => m.ReferralInfoModule
		// 			),
		// 	},
		// 	{
		// 		path: 'pet-details',
		// 		loadChildren: () =>
		// 			import('./pages/quoting/pet-details/pet-details.module').then((m) => m.PetDetailsModule),
		// 	},
		// 	{
		// 		path: 'quote',
		// 		loadChildren: () => import('./pages/quoting/quote/quote.module').then((m) => m.QuoteModule),
		// 	},
		// 	{
		// 		path: 'contact-info',
		// 		loadChildren: () =>
		// 			import('./pages/quoting/contact-info/contact-info.module').then(
		// 				(m) => m.ContactInfoModule
		// 			),
		// 	},
		// 	{
		// 		path: 'acknowledgements',
		// 		loadChildren: () =>
		// 			import('./pages/quoting/acknowledgements/acknowledgements.module').then(
		// 				(m) => m.AcknowledgementsModule
		// 			),
		// 	},
		// 	{
		// 		path: 'billing',
		// 		loadChildren: () =>
		// 			import('./pages/quoting/billing/billing.module').then((m) => m.BillingModule),
		// 	},
		// 	{
		// 		path: 'success',
		// 		loadChildren: () =>
		// 			import('./pages/quoting/success/success.module').then((m) => m.SuccessModule),
		// 	},
		// ],
	},
	{ path: '', redirectTo: 'quoting/start-quote', pathMatch: 'full' },
	{ path: '**', redirectTo: 'quoting/start-quote' },
]

const isIframe: boolean = window !== window.parent && !window.opener

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
